import React from "react";
import { Link } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import ResultItem from "./ResultItem";

const CustomerResult = ({ customers = [] }) => {
  return (
    <Box>
      <div className="mb-2 px-5 font-semibold">Customers</div>

      {customers.map((customer, index) => (
        <Link
          to={`/app/crm/customerProfile/${customer?._id}/detail`}
          key={customer?._id}
        >
          <ResultItem
            title={customer?.customerUser?.name}
            subtitle={customer.phone}
            icon={() => <AccountCircleIcon color="primary" />}
          />

          {index !== customers.length - 1 && <Divider />}
        </Link>
      ))}
    </Box>
  );
};

export default CustomerResult;

 